import { fireBaseAuth, firebaseStorage, fireBaseDatabase } from './config'

export const firebaseObserveAuth = () => new Promise((resolve, reject) => {
  return fireBaseAuth().onAuthStateChanged((user) => {
    if(user){
      resolve(user)
    } else {
      reject({ code: 'auth/not-login', message: 'client: user is not logged in.' })
    }
  })
})

export const signIn = ({ email, password }) => {
  console.log('email', email)
  console.log('password', password)
  return fireBaseAuth().signInWithEmailAndPassword(email, password)
}

export const signOut = () => fireBaseAuth().signOut()


export const getIdToken = () => {
  const user = fireBaseAuth().currentUser
  if(user){
    return user.getIdToken()
  }
  return Promise.resolve('no-id-token')
}

export const uploadAsset = (storeId, file) => new Promise((resolve, reject) => {
  const uploadTask = firebaseStorage().ref(`${storeId}/${file.name}`).put(file)

  uploadTask.on(
    'state_changed',
    () => {},
    (err) => reject(err),
    () => {
      resolve(uploadTask.snapshot.downloadURL)
    }
  )
})

export const writeData = (storeId, path, data) => {
  return fireBaseDatabase().ref(`${storeId}/${path}`).set(data)
}

export const readOnData = (storeId, path, callback) => {
  return fireBaseDatabase().ref(`${storeId}/${path}`).on('value', (snapshot) => {
    return callback(snapshot.val())
  })
}


// WEBPACK FOOTER //
// ./src/firebase/functions.js